/** @todo REMOVER ESTE ARQUIVO ASSIM QUE A MIGRAÇÃO STYLED-COMPONENTS FOR CONCLUÍDA */

// TEXT
export const TEXT_COLOR_DEFAULT = {
  default: '#363839',
  propx: '#ffffff',
};
export const TEXT_COLOR_DIM = {
  default: '#6d7278',
  propx: '#b6b6b6',
};
export const TEXT_COLOR_DIM2 = {
  default: '#a4aaad',
  propx: '#898586',
};
export const TEXT_COLOR_INVERTED = {
  default: '#ffffff',
  propx: '#363839',
};

// BORDERS
export const BORDER_COLOR = {
  default: '#e6e6e6',
  propx: '#444444',
};

// COLORS
export const COLOR_PRIMARY = {
  default: '#d3461e',
  propx: '#95c52d',
};
export const COLOR_ERROR = {
  default: '#ff5252',
  propx: '#FF5C5C',
};
export const COLOR_SUCCESS = {
  default: '#1da57a',
  propx: '#95c52d',
};
export const COLOR_DISABLED = {
  default: '#dddddd',
  propx: '#444444',
};

export const COLOR_LEVEL_CRITICAL_LIGHT = {
  default: '#ffd3d3',
  propx: '#ffd3d3',
};
export const COLOR_LEVEL_WARNING_LIGHT = {
  default: '#ffe9bf',
  propx: '#ffe9bf',
};
export const COLOR_LEVEL_NICE_LIGHT = {
  default: '#b8f3dc',
  propx: '#b8f3dc',
};
export const COLOR_LEVEL_NICE = {
  default: '#00C561',
  propx: '#95c52d',
};
export const COLOR_LEVEL_WARNING = {
  default: '#ffbf31',
  propx: '#ffbf31',
};
export const COLOR_LEVEL_COLD = {
  default: '#739ebc',
  propx: '#739ebc',
};
export const COLOR_LEVEL_CRITICAL = {
  default: '#FF5C5C',
  propx: '#FF5C5C',
};
export const COLOR_LEVEL_CRITICAL_DARK = {
  default: '#d10000',
  propx: '#ea0000',
};
export const COLOR_LEVEL_WARNING_DARK = {
  default: '#b79800',
  propx: '#da9f00',
};
export const COLOR_LEVEL_NICE_DARK = {
  default: '#178e6a',
  propx: '#0bbc88',
};

// BACKGROUND
export const BACKGROUND_NEUTRAL = {
  default: '#f1f1f1',
  propx: '#252323',
};
export const BACKGROUND_ELEMENT = {
  default: '#fff',
  propx: '#130c0e',
};

// CHART COLORS
export const CHART_COLORS = [
  '#65B8FD',
  '#FC8D8E',
  '#1DC391',
  '#60BDDA',
  '#6074DA',
  '#9660DA',
  '#DAD560',
  '#DA6F60',
  '#DA8C60',
  '#60DADA',
  '#DA6093',
  '#60DA82',
];

// GENERAL
export const APP_CONTAINER_PADDING = '0 100px';
